import infinityText from '../modules/infinityText';

try {
infinityText();
//Carregar mais produtos//
const btnSeeMore = document.querySelector(".see__more")
    btnSeeMore.addEventListener('click', ()=>{
        seeMoreProducts()
    })
} catch (error) {

}

function seeMoreProducts(){
    const containerProducts = document.querySelector(".container__products")
    containerProducts.classList.toggle("active")

    const contentBtn = document.querySelector('.content__seemore')
    contentBtn.innerHTML === 'Carregar mais' ? contentBtn.innerHTML = 'Carregar menos' : contentBtn.innerHTML = 'Carregar mais'
}

/** Filter Products */

$('#searchByProduct').on('keyup', function(event) {
    let url = $("#routeSearchCat").val();
    let q = $('#searchByProduct').val();
    let id = $('#routeSearchCat').attr('category');
    if (id == undefined) {
        id = "";
    }
    let dataString = `t=${q}&id=${id}`;

    search(dataString, url);

});

$('#searchByCode').on('keyup', function(event) {
    let url = $("#routeSearchCode").val();
    let c = $('#searchByCode').val();
    let id = $('#routeSearchCode').attr('category');
    if (id == undefined) {
        id = "";
    }
    let dataString = `c=${c}&id=${id}`;

    search(dataString, url);

});

function search(dataString, url) {
    $.ajax({
        type: "POST",
        url: url,
        headers: {
            'X-CSRF-Token': $('input[name="_token"]').val()
        },
        data: dataString,
        dataType: 'json',
        success: function (json) {
            let data = json;
            let content = data.content;
            $('[name="products"]').css({'display': 'none'});
            $('[name="categorias"]').css({'display': 'none'});
            content.forEach(el => {
                $(`#Cat-${el.id_category}`).css({'display': 'block'});
                $(`#${el.id}`).css({'display': 'block'});
            });
        }
    });
}


